import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon } from '@icons';
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import useFocus from '../common/effects/useFocusNew';
import { withOverlay } from '../common/withOverlay';
import styles from './global-notification.module.scss';
const GlobalNotification = ({ height = 50, delay = 0, closeAfter = 3000, message, state = 'info', onClose, hideAnimationStyle = 'hide', focusable = true, size = 'md', }) => {
    const [open, setOpen] = useState(false);
    const btnCloseRef = useRef(null);
    useFocus(focusable ? btnCloseRef : null, focusable ? () => setOpen(false) : null);
    useEffect(() => {
        setTimeout(() => setOpen(true), delay);
    }, []);
    useEffect(() => {
        if (open) {
            setTimeout(() => {
                setOpen(false);
                setTimeout(() => onClose?.(), 250);
            }, closeAfter);
        }
    }, [open]);
    const globalNotificationClass = useMemo(() => classNames(styles.global_notification, {
        [styles.close]: !open,
        [styles.open]: open,
        [styles[state]]: true,
        [styles[`animation_${hideAnimationStyle}`]]: true,
        [styles[size]]: true,
    }), [open, state, hideAnimationStyle]);
    const style = useMemo(() => ({
        '--height': `${height}px`,
    }), []);
    const handleClose = useCallback(() => {
        setOpen(false);
        onClose?.();
    }, []);
    return (_jsxs("div", { className: globalNotificationClass, style: style, role: "alert", children: [_jsx("span", { className: styles.message, children: open && message }), _jsx("span", { className: styles.close_btn, onClick: handleClose, role: "button", ref: btnCloseRef, tabIndex: focusable ? 0 : -1, children: open && _jsx(CloseIcon, {}) })] }));
};
GlobalNotification.displayName = 'GlobalNotification';
const GlobalNotificationOverlay = withOverlay(GlobalNotification, {
    backdropColor: 'transparent',
    name: 'globalNotification',
});
export { GlobalNotificationOverlay as GlobalNotification };
